import {removePageMessage, setPageMessage} from '../actions/pageMessageActions';
import Language from '../lang/language';
import store from '../store/store';
import DomUtils from '../utils/DomUtils';
import V2Components from '../v2-components.js';

export const getPageError = (errors) => {
  for (const error of errors) {
    if (error.pageError) {
      return Language.getText(error.pageError);
    }
  }
};

const Validation = {
  validate(componentNames) {
    let allValid = true;
    let errors = [];
  
    if (!componentNames) {
      V2Components.list().forEach((component) => {
        if (!component) {
          console.warn('component is missing:', component);
        } else if (!component.validate) {
          console.warn('component does not have isValid method, ignoring', component);
        } else {
          const validationResult = component.validate();
          allValid = validationResult.isValid && allValid;
          if (validationResult.errors) {
            errors = errors.concat(validationResult.errors);
          }
        }
      });
    
      if (!allValid) {
        setTimeout(DomUtils.scrollToTop, 0); // setTimeout 0 to scroll /after/ React components have re-rendered (was causing it not to scroll)
      }
    } else {
      if (!Array.isArray(componentNames)) {
        componentNames = [componentNames];
      }
  
      componentNames.forEach((name) => {
        const component = V2Components.get(name);
        if (!component) {
          console.warn('component is missing:', component);
        } else if (!component.validate) {
          console.warn('component does not have isValid method, ignoring', component);
        } else {
          const validationResult = component.validate();
          allValid = validationResult.isValid && allValid;
          if (validationResult.errors) {
            errors = errors.concat(validationResult.errors);
          }
        }
      });
    }
    const validationResult = {isValid: allValid, errors: undefined};
    if (allValid) {
      store.dispatch(removePageMessage());
    } else {
      const pageErrorToShow = getPageError(errors);
      store.dispatch(setPageMessage(pageErrorToShow));
      validationResult.errors = errors;
    }
  
    return validationResult;
  },
};

export default Validation;
